<template>
    <div class="questionnaire-action">
        <el-tooltip :disabled="!combNoteDisabled" class="push-btn-container" content="Disabled for manually created events">
            <button class="push-button" v-popover:popover
                v-if="hasPushIntegration && emrCategory.length == 0"
                :disabled="combNoteDisabled"
                @click="saveEmrNote({ emrId: 'default'})">
                {{ pushing ? 'Pushing' : 'Push' }} <i class="el-icon-arrow-down"></i>
            </button>
        
            <el-dropdown v-else-if="hasPushIntegration && emrCategory.length > 0"
                :disabled="combNoteDisabled || hasNoteBeenEdited"
                @command="emrSelected" v-popover:popover>
                <button :disabled="combNoteDisabled" class="push-button">
                    {{ pushing ? 'Pushing...' : 'Push' }}  <i class="el-icon-arrow-down" style="font-size: 12px"></i>
                </button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                    :key="emr.id"
                    v-for="emr in emrCategory"
                    placement="bottom"
                    :command="{ emrId: emr.id, emrTitle: emr.title}">
                        <div class="dropdwn-cnt">
                            <span class="option-title">{{ emr.title }} </span>
                            <span v-if="emr.last_pushed && emr.last_pushed !== ''" class="timestamp">
                                <span id="content1" style="line-height: 13px; margin-top: 10px" v-html="getFormattedLastPushed(emr.last_pushed)"></span>
                            </span>
                        </div>
                    </el-dropdown-item>
                    <span class="info" v-if="emrCategory.some(({disabled}) => disabled)">
                        <img :src="require('../image/info-icon.png')" />
                        Notes have been Pushed to {{ emrCategory.filter((emr) => emr.disabled).map(({ title }) => `'${title}'`).join(', ') }}
                    </span>
                </el-dropdown-menu>
            </el-dropdown>
        </el-tooltip>
        <button class="questionnaire-copy-button" @click="copyToClip()" :disabled="hasNoteBeenEdited">
            <i class="el-icon-copy-document"></i> Copy
        </button>
        <button v-if="savable" class="questionnaire-save-button" @click="updateChartNote" :disabled="!hasNoteBeenEdited || updating">
            <i v-if="updating" class="el-icon-loading"></i>
            <img v-else src="./img/save.svg" />
            Save
        </button>
    </div>
</template>

<script>
export default {
    name: 'note-actions',

    props: {
        emrCategory: {
            type: Array
        },
        hasPushIntegration: {
            type: Boolean
        },
        hasNoteBeenEdited: {
            type: Boolean
        },
        combNoteDisabled: {
            type: Boolean
        },
        pushing: {
            type: Boolean
        },
        disablePush: {
            type: Boolean
        },
        updating: {
            type: Boolean
        },
        savable: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        saveEmrNote(emr) {
            this.$emit('save-emr-note', emr)
        },
        emrSelected(emr) {
            // If its a new version of the note, then update through new api
            if(this.savable)
                this.$emit('new-emr-selected', emr)
            else
                this.$emit('emr-selected', emr)
        },
        copyToClip() {
            this.$emit('copy-to-clip')
        },
        updateChartNote() {
            this.$emit('update-chart-note')
        },
        getFormattedLastPushed(lastPushed) {
            let arr = lastPushed.split(' ')
            if (arr.length === 5)
                return 'Last: ' + arr.slice(0, 3).join(' ') + '<br>' + arr.slice(3, 6).join(' ')
            return lastPushed
        },
    }
}
</script>

<style scoped lang="scss">
@import './style.scss';

.questionnaire-action {
    flex-grow: 1;
    height: 28px;
    > button {
        height: 100%;
    }
}

.push-btn-container {
    float: right;
}
.push-button, .push-button:hover {
    font-size: 13px;
    font-weight: 500;
    background-color: #833e93;
    height: 28px;
    margin-left: 10px;
    color: #FFFFFF;
    border: none;
    border-radius: 5px;
    padding: 8px 8px !important;
    &:disabled {
        opacity: 0.6;
    }
    i {
        font-size: 11px;
        color: #FFFFFF;
    }
}
.dropdwn-cnt{
    display: inline-block;
    height: 45px !important;
    min-width: 250px;
}
.option-title {
    display: inline-block;
    margin-top: 14px;
    width: 70%;
    line-height: 1.4;
}
.timestamp{
    color: #999999;
    font-size: 10px;
    width: 35%;
    position: absolute;
    right: 10px;
    display: inline-block;
    text-align: right;

    span {
        height: 15px;
        display: block;
    }
}
.info {
    display: flex;
    background-color: #FFF3E3;
    color: #FA9E25;
    margin-bottom: -10px;
    padding: 8px 12px;
    font-size: 12px;
    max-width: 200px;
    img {
        height: 10px;
        width: 10px;
        margin-right: 5px;
    }
}

</style>
